<template>




    <section id="search-main" class="section">




        <div id="main-overlay" class="container is-desktop">

            <div class="f-search-fg">
                <h1>Aqui encontra os melhores profissionais para o seu serviço!<br>
                    Diga-nos o que precisa e enviaremos as 5 melhores propostas até 48 horas!
                </h1>

                <div class="columns">
                    <div class="column pb0 is-four-fifths-tablet">




                        <search-drop-down
                                :services="services"
                                @setParentService="$emit('setParentService',$event)"
                                @openOrderModal="$emit('openOrderModal')">
                        </search-drop-down>




                    </div>
                </div>


                <div id="main-icons" class="f-search-icons-group is-hidden-mobile">
                    <div class="columns is-mobile">
                        <div class="column f-search-icons is-1-tablet is-2-mobile"> <!--@click="$router.push({path:'/imoveis'})"-->
                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                 x="0px" y="0px" width="54.875px" height="53.625px" viewBox="0 0 54.875 53.625"
                                 enable-background="new 0 0 54.875 53.625" xml:space="preserve">
                                <circle fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" cx="27.336" cy="26.528" r="23.531"/>
                                <polygon fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" points="37.279,24.139 37.279,19.295 33.568,15.446
                                33.568,20.266 27.347,13.773 13.979,27.701 17.264,27.701 17.264,39.281 37.307,39.281 37.307,27.701 40.693,27.701 "/>
                            </svg>
                            <p style="min-width: 4rem; text-align: center;">Imóveis</p>
                        </div>

                        <div class="column f-search-icons is-1-tablet is-2-mobile" @click="$router.push({path:'/casa'})">

                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                 width="54.875px" height="53.625px" viewBox="0 0 54.875 53.625" enable-background="new 0 0 54.875 53.625" xml:space="preserve">
                                <circle fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" cx="27.336" cy="26.528" r="23.531"/>

                                <path fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" d="M35.846,26.358c5.41,0.233,7.215-5.062,7.271-5.468
                                    c0.039-0.273,0.043-0.315-0.408-0.66c-0.439-0.453-0.615-0.132-0.721-0.125l-3.467,2.414c-3.082-1.105-2.732-4.307-2.732-4.307
                                    l3.291-2.214c0.018-0.192,0.029-0.296-0.055-0.516c-0.016-0.067-0.074-0.199-0.154-0.261c-8.652-2.371-8.123,7.125-8.123,7.125
                                    s-1.229,1.223-3.049,2.932c-0.27-0.275-0.78-0.678-0.78-0.678s-0.545-0.494-0.951-0.166c-0.227,0.183-4.206-3.643-2.345-5.969
                                    c0,0,0.643-0.86,1.455-0.6c0,0,0.593,0.183,1-0.167c0.407-0.348,1.735-1.688,1.735-1.688s-1.508-4.021-4.592-4.661
                                    c0,0-1.688,1.222-2.093,1.862c-0.407,0.64,0.058,1.803-0.815,2.444c-0.872,0.639-11.809,6.107-7.62,15.824
                                    c0,0,1.396,0.232,1.745-0.35c0.349-0.583-1.627-4.481,2.095-6.226c0,0,3.896-1.686,6.34,1.804c0,0-0.483,0.415-0.295,0.884
                                    c0.093,0.233,0.371,0.532,1.156,1.48c-3.458,3.25-6.873,6.488-6.969,6.594c-0.862,0.943-1.279,1.514-1.279,1.514
                                    s-1.322,1.77,0.823,3.697c1.844,1.656,3.364,0.314,3.364,0.314s4.009-3.928,7.868-7.691c2.914,3.289,6.255,6.875,7.607,7.869
                                    c0,0,1.047,0.619,2.328-0.584c0.783-0.732,1.918-2.152,1.918-2.152s0.604-0.922-0.057-1.629c-0.246-0.262-4.25-4.279-7.551-7.639
                                    c1.566-1.518,2.672-2.581,2.781-2.658C34.975,26.417,35.846,26.358,35.846,26.358z"/>
                            </svg>
                            <p style="min-width: 4rem; text-align: center;">Casa</p>
                        </div>

                        <div class="column f-search-icons is-1-tablet is-2-mobile" @click="$router.push({path:'/certificacao'})">

                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                 width="54.875px" height="53.625px" viewBox="0 0 54.875 53.625" enable-background="new 0 0 54.875 53.625" xml:space="preserve">
                                <circle fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" cx="27.336" cy="26.528" r="23.531"/>

                                <g>
                                    <polyline fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" points="18.352,36.906 18.352,15.901
                                        16.474,14.051 14.597,15.901 14.597,36.906 	"/>
                                    <polyline fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" points="25.864,36.906 25.864,19.096
                                        23.986,17.246 22.108,19.096 22.108,36.906 	"/>
                                    <polyline fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" points="33.375,36.906 33.375,22.925
                                        31.498,21.075 29.619,22.925 29.619,36.906 	"/>
                                    <polyline fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" points="40.887,36.906 40.887,27.077
                                        39.01,25.228 37.131,27.077 37.131,36.906 	"/>
                                </g>
                            </svg>
                            <p style="min-width: 4rem; text-align: center;">Certificação</p>
                        </div>

                        <div class="column f-search-icons is-1-tablet is-2-mobile" @click="$router.push({path:'/climatizacao'})">
                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                 width="54.875px" height="53.625px" viewBox="0 0 54.875 53.625" enable-background="new 0 0 54.875 53.625" xml:space="preserve">
                                <circle fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" cx="27.336" cy="26.528" r="23.531"/>
                                <path fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" d="M22.559,39.46c0,0-6.115-1.377-6.115-9.123
                                    c0-7.748,4.435-7.749,4.435-12.794c0,0,1.479,3.161,0.407,5.709c-1.071,2.548,2.189,4.9,2.189,4.9s-1.201-3.422,1.603-7.55
                                    c2.802-4.129,2.344-8.614,2.344-8.614s3.568,4.23,3.721,7.899c0.152,3.671-0.861,3.86,0.57,5.836c0,0-0.115-3.388,3.35-6.701
                                c0,0-1.069,3.058,1.685,6.473c2.75,3.416,1.939,11.519-4.687,13.965"/>
                            </svg>
                            <p style="min-width: 4rem; text-align: center;">Climatização</p>
                        </div>

                        <div class="column f-search-icons is-1-tablet is-2-mobile" @click="$router.push({path:'/aulas'})">
                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                 width="54.875px" height="53.625px" viewBox="0 0 54.875 53.625" enable-background="new 0 0 54.875 53.625" xml:space="preserve">
                                <circle fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" cx="27.336" cy="26.528" r="23.531"/>
                                <g>
                                    <g>
                                        <g>
                                            <path fill="currentColor" d="M41.273,17.997H39.18v-2.168c0-0.497-0.365-0.918-0.855-0.991c-0.084-0.013-2.125-0.309-4.584,0.138
                                                c-2.738,0.499-4.922,1.728-6.404,3.586c-1.481-1.858-3.666-3.087-6.405-3.586c-2.457-0.447-4.498-0.15-4.583-0.138
                                                c-0.491,0.073-0.854,0.495-0.854,0.991v2.168H13.4c-0.554,0-1.003,0.449-1.003,1.002v18.894c0,0.325,0.157,0.63,0.422,0.818
                                                c0.265,0.188,0.604,0.236,0.91,0.129c0.075-0.025,7.589-2.591,13.191-0.034c0.264,0.121,0.567,0.121,0.832,0
                                                c5.587-2.549,13.117,0.009,13.193,0.034c0.105,0.038,0.217,0.056,0.328,0.056c0.207,0,0.41-0.062,0.582-0.185
                                                c0.264-0.188,0.42-0.493,0.42-0.818V18.999C42.275,18.446,41.826,17.997,41.273,17.997z M14.402,36.552v-16.55h1.092v13.353
                                                c0,0.292,0.127,0.569,0.348,0.759c0.221,0.189,0.514,0.276,0.802,0.232c0.055-0.007,4.411-0.605,7.593,1.577
                                                C20.317,35.253,16.394,36.028,14.402,36.552z M26.333,35.02c-1.401-1.267-3.227-2.122-5.402-2.52
                                                c-1.047-0.189-2.018-0.245-2.794-0.245c-0.23,0-0.444,0.006-0.637,0.013V16.75l0,0c1.927-0.087,6.614,0.119,8.834,3.881V35.02z
                                                 M28.338,20.631c2.212-3.747,6.908-3.962,8.835-3.879v15.516C36.33,32.234,35.1,32.254,33.74,32.5
                                                c-2.174,0.397-4,1.253-5.402,2.52V20.631L28.338,20.631z M30.432,35.924c3.184-2.184,7.541-1.586,7.598-1.578
                                                c0.287,0.044,0.58-0.041,0.801-0.231c0.223-0.19,0.35-0.467,0.35-0.76V20.002h1.09v16.55
                                                C38.279,36.028,34.354,35.253,30.432,35.924z"/>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                            <p style="min-width: 4rem; text-align: center;">Aulas</p>
                        </div>

                        <div class="column f-search-icons is-1-tablet is-2-mobile" @click="$router.push({path:'/outros'})">
                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                 width="54.875px" height="53.625px" viewBox="0 0 54.875 53.625" enable-background="new 0 0 54.875 53.625" xml:space="preserve">
                                <circle fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" cx="27.336" cy="26.528" r="23.531"/>
                                <g>
                                    <g>
                                        <g>
                                            <path fill="currentColor" d="M35.986,32.203c-0.586-1.223-2.683-2.92-4.709-4.559c-1.131-0.914-2.198-1.777-2.879-2.458
                                                c-0.17-0.172-0.426-0.227-0.651-0.146c-0.419,0.152-0.678,0.269-0.882,0.36c-0.311,0.139-0.416,0.187-0.835,0.229
                                                c-0.186,0.019-0.352,0.118-0.456,0.272c-0.88,1.316-1.791,1.204-2.399,1c-0.194-0.064-0.229-0.147-0.248-0.228
                                                c-0.13-0.546,0.525-1.818,1.375-2.668c2.022-2.024,3.065-2.531,5.268-1.546c2.5,1.118,5.004,1.993,5.029,2.001
                                                c0.327,0.114,0.68-0.058,0.793-0.383c0.111-0.325-0.059-0.68-0.384-0.792c-0.024-0.009-2.479-0.866-4.929-1.963
                                                c-2.854-1.276-4.42-0.436-6.657,1.802c-0.851,0.851-2.007,2.574-1.709,3.837c0.128,0.538,0.507,0.936,1.069,1.121
                                                c1.41,0.467,2.697,0.021,3.656-1.252c0.396-0.061,0.611-0.15,0.935-0.296c0.117-0.052,0.254-0.113,0.436-0.187
                                                c0.712,0.668,1.673,1.446,2.685,2.264c1.83,1.48,3.904,3.158,4.371,4.129c0.23,0.479-0.018,0.791-0.186,0.935
                                                c-0.246,0.212-0.584,0.278-0.766,0.151c-0.202-0.139-0.465-0.147-0.673-0.023c-0.209,0.125-0.325,0.359-0.3,0.602
                                                c0.043,0.396-0.32,0.623-0.477,0.701c-0.398,0.201-0.814,0.166-0.97,0.021C31.32,34.965,31.07,34.918,30.85,35
                                                c-0.223,0.084-0.377,0.288-0.398,0.524c-0.037,0.408-0.34,0.8-0.734,0.953c-0.191,0.072-0.467,0.116-0.715-0.11
                                                c-0.154-0.14-0.369-0.193-0.569-0.145c-0.203,0.05-0.366,0.197-0.437,0.393c-0.024,0.062-0.078,0.211-0.66,0.211
                                                c-0.415,0-1.16-0.279-1.524-0.521c-0.437-0.287-3.176-2.331-5.542-4.312c-0.333-0.28-0.907-0.881-1.415-1.41
                                                c-0.451-0.471-0.863-0.897-1.074-1.076c-0.265-0.225-0.657-0.191-0.877,0.072c-0.222,0.264-0.189,0.656,0.073,0.878
                                                c0.193,0.163,0.566,0.558,0.979,0.987c0.555,0.58,1.129,1.18,1.515,1.504c2.317,1.939,5.103,4.035,5.658,4.399
                                                c0.458,0.301,1.445,0.724,2.209,0.724c0.614,0,1.085-0.14,1.413-0.415c0.438,0.17,0.936,0.172,1.415-0.015
                                                c0.566-0.219,1.032-0.661,1.296-1.196c0.491,0.104,1.052,0.03,1.562-0.226c0.499-0.252,0.86-0.636,1.039-1.085
                                                c0.495,0.026,1.006-0.149,1.427-0.512C36.203,34.011,36.4,33.061,35.986,32.203z"/>
                                        </g>
                                    </g>
                                    <g>
                                        <g>
                                            <path fill="currentColor" d="M24.848,21.891h-5.601c-0.344,0-0.623,0.279-0.623,0.622c0,0.344,0.279,0.623,0.623,0.623h5.601
                                                c0.343,0,0.622-0.279,0.622-0.623C25.47,22.169,25.191,21.891,24.848,21.891z"/>
                                        </g>
                                    </g>
                                    <g>
                                        <g>
                                            <path fill="currentColor" d="M37.811,30.878c-0.193-0.284-0.579-0.363-0.863-0.169l-1.82,1.223c-0.285,0.191-0.361,0.578-0.17,0.863
                                                c0.121,0.178,0.318,0.275,0.519,0.275c0.118,0,0.239-0.034,0.347-0.106l1.818-1.222C37.926,31.551,38.002,31.163,37.811,30.878z"
                                                />
                                        </g>
                                    </g>
                                    <g>
                                        <g>
                                            <path fill="currentColor" d="M33.947,33.848c-0.445-0.351-2.438-2.391-3.671-3.676c-0.237-0.248-0.632-0.258-0.88-0.018
                                                c-0.249,0.237-0.256,0.632-0.019,0.879c0.319,0.334,3.142,3.275,3.798,3.793c0.113,0.09,0.25,0.133,0.384,0.133
                                                c0.183,0,0.366-0.082,0.491-0.237C34.263,34.453,34.217,34.061,33.947,33.848z"/>
                                        </g>
                                    </g>
                                    <g>
                                        <g>
                                            <path fill="currentColor" d="M31.46,35.096c-0.745-0.596-2.619-2.586-3.042-3.047c-0.234-0.254-0.626-0.269-0.88-0.037
                                                c-0.252,0.232-0.27,0.627-0.037,0.881c0.022,0.023,2.258,2.437,3.181,3.176c0.115,0.091,0.254,0.136,0.389,0.136
                                                c0.182,0,0.363-0.081,0.486-0.233C31.771,35.703,31.729,35.311,31.46,35.096z"/>
                                        </g>
                                    </g>
                                    <g>
                                        <g>
                                            <path fill="currentColor" d="M28.983,36.35c-0.888-0.748-2.704-2.682-3.058-3.061c-0.235-0.252-0.63-0.266-0.88-0.029
                                                c-0.251,0.234-0.264,0.628-0.03,0.879c0.511,0.547,2.248,2.389,3.166,3.163c0.117,0.099,0.259,0.147,0.401,0.147
                                                c0.176,0,0.353-0.076,0.477-0.223C29.279,36.963,29.246,36.571,28.983,36.35z"/>
                                        </g>
                                    </g>
                                    <g>
                                        <g>
                                            <path fill="currentColor" d="M19.675,20.816c-1.067-1.011-5.333-1.338-6.614-1.414c-0.177-0.009-0.34,0.05-0.464,0.168
                                                c-0.125,0.117-0.195,0.281-0.195,0.453v11.202c0,0.343,0.279,0.622,0.622,0.622h3.734c0.269,0,0.508-0.173,0.591-0.43
                                                c0.091-0.278,2.235-6.86,2.518-10.096C19.882,21.132,19.813,20.946,19.675,20.816z M16.303,30.604h-2.657v-9.913
                                                c2,0.158,4.158,0.501,4.942,0.882C18.258,24.299,16.766,29.142,16.303,30.604z"/>
                                        </g>
                                    </g>
                                    <g>
                                        <g>
                                            <path fill="currentColor" d="M41.65,20.646c-4.887,0-7.598,1.25-7.711,1.303c-0.162,0.076-0.282,0.216-0.332,0.387
                                                c-0.05,0.171-0.025,0.354,0.068,0.505c0.77,1.238,3.178,8.117,3.641,9.794c0.074,0.271,0.32,0.456,0.6,0.456h3.734
                                                c0.344,0,0.622-0.278,0.622-0.621V21.268C42.272,20.923,41.994,20.646,41.65,20.646z M41.027,31.848h-2.646
                                                c-0.59-1.922-2.332-6.933-3.304-9.004c0.95-0.322,2.989-0.876,5.95-0.946V31.848z"/>
                                        </g>
                                    </g>
                                </g>
                            </svg>

                            <p style="min-width: 4rem; text-align: center;">Outros</p>
                        </div>
                    </div>
                </div>


            </div>
        </div>

            <!-- Slider main container -->
        <div class="swiper-container-search">
            <!-- Additional required wrapper -->
            <div class="swiper-wrapper">
                <!-- Slides -->

                <div class="swiper-slide">
                    <div class="f-search-bg" style="background-image: url('/static/images/search_main/bannerImoveis.jpg')">

                    </div>
                    <div class="f-search-footer">
                        <img src="/static/images/search_main/LogoImoveis.png" alt="Imóveis">
                        <span>Procura um imóvel? Encontre-o no Facilimo &nbsp;</span>
                        <i class="fa fa-long-arrow-right fa-2x"></i>
                    </div>
                </div>
                <div class="swiper-slide" v-for="slide in lastSlides">
                    <div class="f-search-bg" :style="slide.style">

                    </div>
                    <div class="f-search-footer">
                        <img :src="slide.icon" :alt="slide.name">
                        <span>{{slide.name}} &nbsp;</span>
                    </div>
                </div>


            </div>



        </div>

        <div id="scroll-down" class="animated infinite bounce" @click="$SmoothScroll(intro,400)">
            <i class="fa fa-angle-down"></i>
            <img src="/static/images/layout/mouse.svg" alt="" >
        </div>





    </section>

</template>

<script>
import AppModalOrder from "./ModalOrder.vue";

//import Swiper from 'swiper';
import SearchDropDown from "./SearchDropDown.vue";

//import { all } from '../plugins/serviceList';

import helpers from "../plugins/helpers";

export default {
  components: {
    SearchDropDown,
    AppModalOrder
  },
  props: ["services"],

  data() {
    return {
      intro: null,

      //services: [],
      //
      service: null,
      //
      orderModal: false,

      lastSlides: [
        {
          name: "Precisa de fazer obras em casa? O profissional está no Facilimo.",
          style:
            "background-image: url('/static/images/search_main/bannerObras.jpg')",
          icon: "/static/images/search_main/LogoObras.png"
        },
        {
          name:
            "Precisa de um Certificado Energético? O profissional está no Facilimo.",
          style:
            "background-image: url('/static/images/search_main/bannerCertificacao.jpg')",
          icon: "/static/images/search_main/LogoCertificacao.png"
        },
        {
          name:
            "Procura por soluções de aquecimento ou climatização? O profissional está no Facilimo.",
          style:
            "background-image: url('/static/images/search_main/bannerAquecimento.jpg')",
          icon: "/static/images/search_main/LogoAquecimento.png"
        },
        {
          name: "Procura um Professor ou Explicador? O Profissional está no Facilimo.",
          style:
            "background-image: url('/static/images/search_main/bannerAulas.jpg')",
          icon: "/static/images/search_main/LogoAulas.png"
        },
        {
          name:
            "Procura um Advogado, Contabilista, Designer, Informático ou outro? O Profissional está no Facilimo.",
          style:
            "background-image: url('/static/images/search_main/bannerOutros.jpg')",
          icon: "/static/images/search_main/LogoOutros.png"
        }
      ],

      isOver: {
        imovel: false,
        obras: false,
        certificacao: false,
        aquecimento: false,
        aulas: false,
        outros: false
      }
    };
  },

  created() {
    this.lastSlides = helpers.shuffle(this.lastSlides);
    this.initialize();
  },
  mounted() {
    this.intro = document.getElementById("intro");

    this.searchSwiper = new Swiper(".swiper-container-search", {
      loop: true,
      simulateTouch: false,
      autoplay: {
        delay: 8000
      }
    });
  },

  methods: {
    initialize() {
      //this.getServices()
    },

    getServices() {
      axios.get(apiUrl + "/api/site/services").then(r => {
        this.services = r.data;
      });
    },

    goSlide(idx) {
      if (typeof this.searchSwiper !== "undefined") {
        this.searchSwiper.slideTo(idx, 400);
      }
    },

    setService(event) {
      if (event.target.value.length > 3) {
        //TODO: replace for helpers.search

        for (let i = 0; i < this.services.length; i++) {
          if (this.services[i]["label"].trim() === event.target.value.trim()) {
            this.service = this.services[i];
            break;
          }
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.imoveis-ico {
  min-height: 4rem;
  min-width: 4rem;
  background-image: url("/static/images/search_main/ICONImoveis.png");
  cursor: pointer;
}
.imoveis-ico:hover {
  background-image: url("/static/images/search_main/ICON-IMOVEIS.png");
}
.obras-ico {
  min-height: 4rem;
  min-width: 4rem;
  background-image: url("/static/images/search_main/ICONObras.png");
  cursor: pointer;
}
.obras-ico:hover {
  background-image: url("/static/images/search_main/ICON-OBRAS.png");
}
.certificacao-ico {
  min-height: 4rem;
  min-width: 4rem;
  background-image: url("/static/images/search_main/ICONCertificacao.png");
  cursor: pointer;
}
.certificacao-ico:hover {
  background-image: url("/static/images/search_main/ICON-CERTIFICACAO.png");
}
.aquecimento-ico {
  min-height: 4rem;
  min-width: 4rem;
  background-image: url("/static/images/search_main/ICONAquecimento.png");
  cursor: pointer;
}
.aquecimento-ico:hover {
  background-image: url("/static/images/search_main/ICON-AQUECIMENTO.png");
}
.aulas-ico {
  min-height: 4rem;
  min-width: 4rem;
  background-image: url("/static/images/search_main/ICONAulas.png");
  cursor: pointer;
}
.aulas-ico:hover {
  background-image: url("/static/images/search_main/ICON-AULAS.png");
}
.outros-ico {
  min-height: 4rem;
  min-width: 4rem;
  background-image: url("/static/images/search_main/ICONOutros.png");
  cursor: pointer;
}
.outros-ico:hover {
  background-image: url("/static/images/search_main/ICON-OUTROS.png");
}

#main-overlay.container {
  padding: 0;
}

#scroll-down {
  opacity: 0.7;
  color: white;
  position: absolute;
  right: 5%;
  bottom: 15%;
  z-index: 3;
  cursor: pointer;
  font-size: 1.5rem;
  padding: 2rem;
}
#scroll-down img {
  height: 1.5rem;
}

.section {
  position: relative;
  border-top: solid 8px #2d3256;
  padding: 0;
}

.f-search-fg {
  line-height: 1.2;
  padding: 4.5rem 2rem 3rem;
  position: absolute;
  z-index: 2;
}

.f-search-fg h1 {
  color: white;
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 2rem;
}

.f-search-icons-group {
  margin: 0 0 1rem;
}

.f-search-icons {
  color: white;
  text-align: center;
  font-size: 0.8rem;
  margin: 2rem 0.5rem 0;
  cursor: pointer;
}

.f-search-icons p {
  margin: 0 -1000%;
}

.f-search-icons svg:hover {
  color: #e90054;
}

.input {
  font-size: 1.5rem;
  height: 4rem;
  border-radius: 5px 0 0 5px;
}

.button {
  font-size: 1.5rem;
  padding: 1em 2rem;
  height: 4rem;
  border-radius: 0 5px 5px 0;
}

.f-search-bg {
  position: relative;
  background-size: cover;
  background-position: center;
}

.f-search-footer {
  background-color: #d8d8d8;
  text-align: center;
  padding: 1rem 0;
}
.f-search-footer img {
  height: 2.5rem;
  width: 2.5rem;
  vertical-align: bottom;
  margin-right: 1rem;
}

.f-search-footer span {
  color: #2d3256;
  font-size: 1.5rem;
  font-style: italic;
  text-align: center;
  line-height: 2.5rem;
  padding: 1rem 0;
}

.f-search-footer i {
  color: #2d3256;
  font-size: 2rem;
  line-height: 2.5rem;
}

@media only screen and (min-width: 769px) {
  .f-search-bg {
    height: 490px;
  }
}

@media only screen and (max-width: 768px) {
  .f-search-footer {
    padding: 0.9rem 0;
  }

  #scroll-down {
    right: -0.5rem;
    bottom: 8rem;
  }

  .f-search-footer img {
    height: 2rem;
    width: 2rem;
    vertical-align: text-bottom;
    margin-right: 1rem;
  }

  .f-search-footer span {
    font-size: 1.5rem;
    line-height: 2rem;
    padding: 1rem 0;
  }
  .f-search-footer i {
    font-size: 1rem;
  }

  .f-search-bg {
    min-height: 32rem;
  }

  .f-search-fg {
    padding: 2rem 2rem 2rem;
  }

  .f-search-icons-group {
    margin-top: 1rem;
    margin-bottom: 2rem;
  }

  .f-search-icons {
    color: white;
    text-align: center;
    font-size: 1rem;
    margin: 2rem -0.5rem 0;
    cursor: pointer;
  }

  .f-search-icons img {
    height: 3rem;
  }

  h1 {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 1rem;
  }

  .input {
    font-size: 1rem;
    height: 3rem;
  }

  .button {
    font-size: 1rem;
    height: 3rem;
    border-radius: 0 5px 5px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SearchMain.vue